import DataSourcesMeasuresCTA from './DataSourcesMeasuresCTA';

export default DataSourcesMeasuresCTA;
